/**
 * Catálogo de tipos de eventos con información de presentación
 * MAPEO OFICIAL DE ICONOS Y TYPES (según especificación):
 * 
 * TYPE                           | NOMBRE ESPAÑOL                          | ICONO CLASS
 * -------------------------------|----------------------------------------|---------------------
 * free_kick_lost                 | Falta cometida                          | .icon-amx-falta
 * free_kick_won                  | Falta recibida                          | .icon-amx-falta
 * miss                           | Disparo desviado                        | .icon-amx-desviado
 * corner                         | Tiro de esquina                         | .icon-amx-tiro-esquina
 * substitution                   | Cambio                                  | .icon-amx-cambio
 * attempt_blocked                | Disparo bloqueado                       | .icon-amx-gol-anulado
 * attempt_saved                  | Disparo atajado                         | .icon-amx-disparo-atajado
 * yellow_card                    | Tarjeta amarilla                        | .icon-amx-tarjeta
 * second_yellow_card             | Segunda amarilla / expulsión            | .icon-amx-segunda-tarjeta
 * red_card                       | Tarjeta roja directa                    | .icon-amx-tarjeta
 * offside                        | Fuera de lugar                          | .icon-amx-fuera-lugar
 * goal                           | Gol                                     | .icon-amx-gol
 * own_goal                       | Autogol                                 | .icon-amx-autogol
 * penalty_goal                   | Gol de penal                            | .icon-amx-gol
 * penalty_won                    | Penal recibido                          | .icon-amx-penal
 * penalty_lost                   | Penal cometido                          | .icon-amx-penal
 * penalty_saved                  | Penal atajado o fallado                 | .icon-amx-disparo-atajado
 * post                           | Poste / travesaño                       | .icon-amx-poste
 * var_cancelled_goal             | Gol anulado por VAR                     | .icon-amx-anulado
 * contentious_referee_decisions  | Decisión del VAR                        | .icon-amx-var
 * start                          | Inicio de cada tiempo                   | .icon-amx-silvato
 * end_1                          | Fin del primer tiempo                   | .icon-amx-silvato
 * end_2                          | Fin del segundo tiempo                  | .icon-amx-silvato
 * end_14                         | Final del partido                       | .icon-amx-silvato
 * added_time                     | Tiempo agregado anunciado               | .icon-tiempo-agregado
 * start_delay                    | Partido detenido                        | .icon-amx-silvato
 * end_delay                      | Se reanuda el partido                   | .icon-amx-silvato
 * lineup                         | Alineaciones confirmadas                | .icon-amx-alineacion
 */

export const EVENT_CATALOG = [
  // GOLES
  { 
    type: "goal", 
    name: "Gol", 
    class_icon: "icon-amx-gol",
    showLabel: true
  },
  { 
    type: "own_goal", 
    name: "Autogol", 
    class_icon: "icon-amx-autogol",
    showLabel: true
  },
  { 
    type: "penalty_goal", 
    name: "Gol de Penal", 
    class_icon: "icon-amx-gol",
    showLabel: true
  },
  
  // TARJETAS
  { 
    type: "yellow_card", 
    name: "Tarjeta Amarilla", 
    class_icon: "icon-amx-tarjeta",
    showLabel: true
  },
  { 
    type: "second_yellow_card", 
    name: "Segunda Amarilla / Expulsión", 
    class_icon: "icon-amx-segunda-tarjeta",
    showLabel: true
  },
  { 
    type: "red_card", 
    name: "Tarjeta Roja Directa", 
    class_icon: "icon-amx-tarjeta",
    showLabel: true
  },
  
  // SUSTITUCIONES Y FALTAS
  { 
    type: "substitution", 
    name: "Cambio", 
    class_icon: "icon-amx-cambio",
    showLabel: true
  },
  { 
    type: "free_kick_lost", 
    name: "Falta Cometida", 
    class_icon: "icon-amx-falta",
    showLabel: true
  },
  { 
    type: "free_kick_won", 
    name: "Falta Recibida", 
    class_icon: "icon-amx-falta",
    showLabel: true
  },
  
  // DISPAROS
  { 
    type: "miss", 
    name: "Disparo Desviado", 
    class_icon: "icon-amx-desviado",
    showLabel: true
  },
  { 
    type: "attempt_blocked", 
    name: "Disparo Bloqueado", 
    class_icon: "icon-amx-gol-anulado",
    showLabel: true
  },
  { 
    type: "attempt_saved", 
    name: "Disparo Atajado", 
    class_icon: "icon-amx-disparo-atajado",
    showLabel: true
  },
  
  // ESQUINAS Y POSTES
  { 
    type: "corner", 
    name: "Tiro de Esquina", 
    class_icon: "icon-amx-tiro-esquina",
    showLabel: true
  },
  { 
    type: "post", 
    name: "Poste / Travesaño", 
    class_icon: "icon-amx-poste",
    showLabel: true
  },
  
  // POSICIÓN
  { 
    type: "offside", 
    name: "Fuera de Lugar", 
    class_icon: "icon-amx-fuera-lugar",
    showLabel: true
  },
  
  // PENALES
  { 
    type: "penalty_won", 
    name: "Penal Recibido", 
    class_icon: "icon-amx-penal",
    showLabel: true
  },
  { 
    type: "penalty_lost", 
    name: "Penal Cometido", 
    class_icon: "icon-amx-penal",
    showLabel: true
  },
  { 
    type: "penalty_saved", 
    name: "Penal Atajado o Fallado", 
    class_icon: "icon-amx-disparo-atajado",
    showLabel: true
  },
  
  // VAR
  { 
    type: "var_cancelled_goal", 
    name: "Gol Anulado por VAR", 
    class_icon: "icon-amx-anulado",
    showLabel: true
  },
  { 
    type: "contentious_referee_decisions", 
    name: "Decisión del VAR", 
    class_icon: "icon-amx-var",
    showLabel: true
  },
  
  // TIEMPOS DEL PARTIDO
  { 
    type: "start", 
    name: "Inicio", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  { 
    type: "end_1", 
    name: "Fin del Primer Tiempo", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  { 
    type: "end_2", 
    name: "Fin del Segundo Tiempo", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  { 
    type: "end_14", 
    name: "Final del Partido", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  
  // RETRASOS Y TIEMPO EXTRA
  { 
    type: "start_delay", 
    name: "Partido Detenido", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  { 
    type: "end_delay", 
    name: "Se Reanuda el Partido", 
    class_icon: "icon-amx-silvato",
    showLabel: true
  },
  { 
    type: "added_time", 
    name: "Tiempo Agregado Anunciado", 
    class_icon: "icon-tiempo-agregado",
    showLabel: true
  },
  
  // ALINEACIONES
  { 
    type: "lineup", 
    name: "Alineaciones Confirmadas", 
    class_icon: "icon-amx-alineacion",
    showLabel: true
  },
];

/**
 * Obtiene la información del evento desde el catálogo
 * @param {string} eventType - Tipo de evento
 * @returns {Object|null} Objeto con name, class_icon, showLabel del evento, o null si no existe
 */
export const getEventCatalogInfo = (eventType) => {
  const event = EVENT_CATALOG.find((e) => e.type === eventType);
  return event || null;
};

/**
 * Verifica si un tipo de evento está en el catálogo
 * @param {string} eventType - Tipo de evento
 * @returns {boolean} True si existe en el catálogo
 */
export const isEventTypeInCatalog = (eventType) => {
  return EVENT_CATALOG.some((e) => e.type === eventType);
};
